import React, { useState, useEffect } from "react";
import ReactApexChart from "react-apexcharts";

const TickerChart = () => {
  const [series, setSeries] = useState([10, 20, 30, 40]);

  const [options] = useState({
    chart: {
      type: "donut", // Fixed the typo
    },
    plotOptions: {
      pie: {
        startAngle: -90,
        endAngle: 270,
      },
    },
    dataLabels: {
      enabled: true,
      formatter: function (val) {
        return val + "%";
      },
      style: {
        fontSize: "14px",
        fontWeight: "bold",
        colors: ['#F0F5FF'],
      },
      background: {
        enabled: true,
        foreColor: '#000',
        borderRadius: 2,
        borderWidth: 0,
        backgroundColor: '#F0F5FF'
      },
      dropShadow: {
        enabled: false,
      },
    },
    stroke: {
      show: false, // ✅ Remove border around donut slices
    },
    colors: ["#2B3779", "#FDB84C", "#6472C0", "#F0C75F"],
    legend: {
      show: false,
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 200,
          },
          legend: {
            show: false,
          },
        },
      },
    ],
    states: {
      hover: {
        filter: {
          type: 'none',
        },
      },
      active: {
        filter: {
          type: 'none',
        },
      },
    },
    tooltip: {
      style: {
        fontSize: "14px",
        color: "#999",
      },
    },
  });

  useEffect(() => {
    fetch("http://localhost/Infomanav_Charts/TickerChart.php", {
      method: "GET",
      headers: {
        "Content-Type": "application/json"
      },
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("API Response:", data); // Debugging ke liye
        setSeries([
          Number(data.missing),
          Number(data.missing_main),
          Number(data.perfect),
          Number(data.isin)
        ]);
      })
      .catch((error) => console.error("Error fetching data:", error));
  }, []);


  return (
    <>
      <div className="ticker-chart-container">
        <ReactApexChart
          options={options}
          series={series}
          type="donut"
          width="100%"
        />
      </div>



      <ul className='custom__legend'>
        <li className='custom__legend_completed'>Completed: <span>320</span></li>
        <li className='custom__legend_pending'>Pending: <span>45</span></li>
        <li className='custom__legend_review'>In Review: <span>80</span></li>
        <li className='custom__legend_rejected'>Rejected: <span>20</span></li>
      </ul>
    </>
  );
};

export default TickerChart;
